import { createContext } from 'react';

import { Holiday, HolidayPayload } from '@totem/components/holidays/types';

interface HolidaysContextValue {
  holidays: Holiday[];
  loading: boolean;
  saving: boolean;
  modalOpen: boolean;
  editingHoliday: Holiday | null;
  refresh: () => void;
  openCreateModal: () => void;
  openEditModal: (holiday: Holiday) => void;
  closeModal: () => void;
  upsertHoliday: (holiday: HolidayPayload) => Promise<void>;
  deleteHoliday: (holidayId: string) => Promise<void>;
}

const HolidaysContext = createContext<HolidaysContextValue>({
  holidays: [],
  loading: false,
  saving: false,
  modalOpen: false,
  editingHoliday: null,
  refresh: () => {},
  openCreateModal: () => {},
  openEditModal: () => {},
  closeModal: () => {},
  upsertHoliday: async () => {},
  deleteHoliday: async () => {},
});

export default HolidaysContext;
